import React, { useEffect, useState } from "react";
import './CadastrarToken.css';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

function getCookie(nome) {
    var nomeEQ = nome + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nomeEQ) === 0) return c.substring(nomeEQ.length, c.length);
    }
    return null;
}

const CadastrarTokenForm = () => {

    const [autorizado, setAutorizado] = useState(null);
    
    useEffect(() => {
        const token = getCookie("info");

        if (!token) {
            alert("Você precisa estar logado para acessar esta página. Redirecionando...");
            window.location.href = "/"; // Redireciona antes da renderização
        } else {
            setAutorizado(true); // Define como autorizado
        }
    }, []);

    const [codigo, setCodigo] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [qrCode, setQrCode] = useState(null);

    const validar_codigo = (evento) => {

        var token_autorizado = getCookie("info")
        
        if (!token_autorizado) {
            window.location.href = "/";
        }

        evento.preventDefault();

        Swal.fire({
            html: 'Verificando o seu login...',
            imageUrl: 'ufo.gif',
            imageWidth: 100,
            imageHeight: 100,
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        fetch(`${process.env.REACT_APP_API_URL}/api/autenticacoes/validar_acesso_otp`, {
            method: 'POST',
            headers: {
                'Authority': token_autorizado,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                codigo: codigo,
            })
        })
            .then((response) => response.json())
            .then((result) => {

                setIsLoading(false);

                if (result.status === "erro") {
                    Swal.fire({
                        text: result.mensagem,
                        icon: "error"
                    });
                    setCodigo("");
                } else {
                    Swal.fire({
                        title: "Conexão estabelecida!",
                        text: "Seu acesso foi autorizado.✨🚀",
                        icon: "success",
                    }).then(() => {
                        setCookie("info", result.token, 1);
                        navigate("/principal");
                    });
                    setCodigo("");
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error);
                Swal.fire({
                    title: "Ops!",
                    text: "Parece que um UFO causou uma interferência. Por favor, tente novamente mais tarde.",
                    icon: "warning"
                });
            });
    };

    function setCookie(nome, valor, dias) {
        var expires = "";
        if (dias) {
            var dias = new Date();
            dias.setTime(dias.getTime() + (24 * 60 * 60 * 1000));
            expires = "; expires=" + dias.toGMTString();
        }
        document.cookie = nome + "=" + (valor || "") + expires + "; path=/";
    }

    if (autorizado === null) {
        return null; // Não renderiza nada até validar
    }

    const gerarQRCode = async () => {

        var token_autorizado = getCookie("info")

        setIsLoading(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/autenticacoes/gerar_chave_otp`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Authority": token_autorizado,
                },
            });

            const result = await response.json();
            setIsLoading(false);

            if (result.status === "erro") {
                Swal.fire({
                    text: result.mensagem,
                    icon: "error"
                });
                setCodigo("");
            } else {
                setQrCode(result.qrcode);
            }
        } catch (error) {
            setIsLoading(false);
            console.error(error);
            Swal.fire({
                title: "Ops!",
                text: "Parece que um UFO causou uma interferência. Por favor, tente novamente mais tarde.",
                icon: "warning"
            });
        }      
         
    };

    return (
        <div className="container-cadastro-token">
            <div className="tutorial-box">
                <h1>Cadastro do Token</h1>

                <p><strong>Passo 1:</strong> Baixe o aplicativo Google Authenticator na Play Store ou App Store.</p>
                <p><strong>Passo 2:</strong> Gere o QR Code no botão abaixo e escaneie no app da Google.</p>
                
                <button onClick={gerarQRCode} className="next-button">
                    {isLoading ? "Gerando QR Code..." : "Gerar QR Code"}
                </button>

                {qrCode && (
                    <div className="qrcode-container">
                        <img src={qrCode} alt="QR Code para Google Authenticator" />
                    </div>
                )}

                <p><strong>Passo 3:</strong> Após se cadastrar no app, digite abaixo o código de 6 dígitos gerado pelo Google Authenticator.</p>

                <div className="input-field">
                <input
                    type="text"
                    placeholder="Digite o código aqui"
                    value={codigo}
                    onChange={(e) => setCodigo(e.target.value)}
                    required
                />
                </div>

                <button onClick={validar_codigo} className="next-button">
                    {isLoading ? "Validando..." : "Validar"}
                </button>
            </div>
        </div>
        );
    };


export default CadastrarTokenForm;
